export default __webpack_public_path__ + "static/media/wingball.6601c864.png";